import React, { useEffect, useState } from "react";
import PrivateApi from '../../services/PrivateApiService';
import { Container, Row } from "react-bootstrap";
import AnlageCard from '../../components/anlage/AnlageCard';
import PlaceholderCard from '../../components/anlage/PlaceholderCard';
import ErrorCard from "../../components/shared/ErrorCard";

const AnlagenPage = () => {

    const API = new PrivateApi();
    const [anlagen, setAnlagen] = useState([]);
    const qr_code = localStorage.getItem('qr') ?? null;
    const [apiError, setApiError] = useState("");

    useEffect(() => {
        if (qr_code !== null) {
            setApiError("");
            API.hw_Anlagen(qr_code)
                .then((res) => {
                    let data = res.data;
                    let grouped = data.reduce((group, anlage) => {
                        const { x_studio_field_6T9W2 } = anlage;
                        group[x_studio_field_6T9W2] = group[x_studio_field_6T9W2] ?? [];
                        group[x_studio_field_6T9W2].push(anlage);
                        return group
                    }, {});
                    setAnlagen(grouped);
                })
                .catch((er) => {
                    setApiError(er.response.data.detail);
                });
        } else {
            setApiError("Kein QR-Code gefunden");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <Container>
            {apiError.length > 1 ? 
                <ErrorCard error={apiError} />   
            :null}
            <h1>Anlagen in diesem Gebäude</h1>
            {Object.keys(anlagen).length > 0? Object.keys(anlagen).map((a, b) => (
                <Row className="justify-content-center mb-5 mt-5">
                    <h4>{a === "False"? "Top nicht zugewiesen": `Top ${a}`}</h4>
                    {anlagen[a].map(anl => (
                        <AnlageCard key={anl.id} anlage={anl} />
                    ))}
                </Row>
            ))
            :
                <Row className="justify-content-center mt-5">
                    <PlaceholderCard />
                </Row>
            }
        </Container>
    )
}

export default AnlagenPage;